import { data } from '../../svg/Grid/data';
import { makeIcon } from '../makeIcon';

export const Grid = makeIcon(data, 'grid', 'Grid');

export default Grid;
